import { GeneratedAxisChart } from '../GeneratedAxisChart/GeneratedAxisChart';
import { ResponsiveLegend } from '../ResponsiveLegend/ResponsiveLegend';
import { useChartSettings } from '../../hooks/useChartSettings/useChartSettings';
import { prepareLegend } from './js/prepareLegend';
import type { ChartWidgetProps } from './ChartWidget.types';
import './css/chart-widget.css';

export const ChartWidget = ({ Chart = GeneratedAxisChart, legend, legend_items, className, ...props }: ChartWidgetProps) => {
  const settings = useChartSettings(props);
  const items = legend === false ? [] : legend?.legend_items ?? prepareLegend({ ...props, legend_items });
  return (
    <div className={['chart-widget', className].filter(Boolean).join(' ')}>
      <div className='chart-widget-legend'>
        {legend !== false && <ResponsiveLegend
          {...legend}
          legend_items={items}
          unit={props.unit}
          grouping_key={props.grouping_key}
          selected={settings.selected}
          handleClick={settings.handleClick}
          checkIfSelected={settings.checkIfSelected}
          checkIfFiltered={settings.checkIfFiltered}
        />}
      </div>
      <div className='chart-widget-chart'>
        <Chart {...props} {...settings} />
      </div>
    </div>
  );
};
